import React, { useState } from "react";
import { uploadPdf, setTokenExpired } from "./intakeApi";

const PROVINCES = ["BC","AB","SK","MB","ON","QC","NB","NS","PEI","NL","YT","NT","NU"];
const CONDITIONS = [
  "Diabetes","Heart disease","High blood pressure","Asthma / COPD",
  "Cancer (current or past)","Thyroid disorder","Depression / anxiety",
  "Kidney disease","Arthritis","Stroke / neurological",
];
const RELATIONSHIPS = ["Spouse / Partner","Parent","Sibling","Child","Friend","Other"];
const today = new Date().toISOString().split("T")[0];
const DAYS   = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const now    = new Date();

/* ─── Global CSS ──────────────────────────────────────────────────────── */
const GLOBAL_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&display=swap');

  .tc-root { background:#EDE3D7; min-height:100vh; padding:32px 16px; font-family:Georgia,serif; }
  .tc-wrap { max-width:740px; margin:0 auto; }

  .tc-clinic-bar {
    display:flex; align-items:center; justify-content:space-between;
    background:white; border:1px solid #D9C9B4; border-radius:14px;
    padding:16px 24px; margin-bottom:18px; gap:20px;
    transition:box-shadow .25s,transform .25s; cursor:default;
  }
  .tc-clinic-bar:hover { box-shadow:0 6px 24px rgba(100,50,10,.10); transform:translateY(-2px); }
  .tc-clinic-left { display:flex; align-items:center; gap:14px; }
  .tc-clinic-logo {
    width:150px; height:150px; background:#C2651A; border-radius:10px;
    display:flex; align-items:center; justify-content:center; flex-shrink:0;
    transition:background .2s,transform .2s;
  }
  .tc-clinic-bar:hover .tc-clinic-logo { background:#A0510E; transform:rotate(-4deg) scale(1.06); }
  .tc-clinic-name { font-size:16px; color:#3D1F0A; letter-spacing:-.3px; }
  .tc-clinic-tag  { font-size:11px; color:#7A5230; margin-top:3px; font-family:'DM Sans',sans-serif; font-weight:500; }
  .tc-clinic-divider { width:1px; height:44px; background:#D9C9B4; flex-shrink:0; }
  .tc-clinic-right { display:flex; flex-direction:column; gap:5px; align-items:flex-end; }
  .tc-clinic-info { display:flex; align-items:center; gap:6px; font-size:12px; color:#5C3A1E; font-family:'DM Sans',sans-serif; font-weight:500; transition:color .15s; }
  .tc-clinic-info:hover { color:#C2651A; }
  .tc-clinic-logo-img {
    height:150px; width:auto; max-width:220px; min-width:60px;
    object-fit:contain; border-radius:10px; display:block; flex-shrink:0;
  }

  .tc-card { background:white; border:1px solid #D9C9B4; border-radius:16px; overflow:hidden; }

  .tc-form-head { display:grid; grid-template-columns:1fr auto; gap:20px; padding:28px 32px 24px; border-bottom:2px solid #C2651A; background:#FFFAF5; }
  .tc-eyebrow { font-size:10px; font-weight:600; letter-spacing:.16em; text-transform:uppercase; color:#C2651A; margin-bottom:10px; font-family:'DM Sans',sans-serif; }
  .tc-form-title { font-size:30px; color:#3D1F0A; line-height:1.08; letter-spacing:-1px; }
  .tc-form-title span { color:#C2651A; }
  .tc-form-sub { font-size:12.5px; color:#5C3A1E; margin-top:10px; font-family:'DM Sans',sans-serif; line-height:1.6; font-weight:500; }
  .tc-date-block { background:#C2651A; color:white; border-radius:12px; padding:14px 18px; text-align:center; min-width:72px; align-self:start; transition:transform .2s,background .2s; cursor:default; }
  .tc-date-block:hover { transform:scale(1.05); background:#A0510E; }
  .tc-date-dow { font-size:10px; font-family:'DM Sans',sans-serif; letter-spacing:.1em; text-transform:uppercase; opacity:.9; margin-bottom:4px; font-weight:600; }
  .tc-date-day { font-size:30px; line-height:1; }
  .tc-date-mon { font-size:11px; font-family:'DM Sans',sans-serif; opacity:.9; margin-top:4px; font-weight:500; }
  .tc-date-yr  { font-size:10px; font-family:'DM Sans',sans-serif; opacity:.75; margin-top:2px; }

  .tc-body { padding:0 32px 32px; }
  .tc-section { padding:24px 0; border-bottom:.5px solid #EAE0D4; }
  .tc-section:last-of-type { border-bottom:none; }

  .tc-slabel { display:flex; align-items:center; gap:10px; font-size:10px; font-weight:600; letter-spacing:.14em; text-transform:uppercase; color:#C2651A; margin-bottom:18px; font-family:'DM Sans',sans-serif; }
  .tc-slabel::after { content:''; flex:1; height:.5px; background:#D9C9B4; }

  .tc-g2 { display:grid; grid-template-columns:1fr 1fr; gap:16px; margin-bottom:16px; }
  .tc-g3 { display:grid; grid-template-columns:1fr 1fr 1fr; gap:16px; margin-bottom:16px; }
  .tc-g2.no-mb,.tc-g3.no-mb { margin-bottom:0; }

  .tc-field { display:flex; flex-direction:column; gap:5px; }
  .tc-field label { font-size:11.5px; color:#5C3A1E; font-family:'DM Sans',sans-serif; font-weight:600; }
  .tc-err-text { font-size:11px; color:#9B2D1F; font-family:'DM Sans',sans-serif; margin-top:2px; }

  .tc-inp { border:none; border-bottom:1.5px solid #D9C9B4; padding:8px 0; font-size:14px; background:transparent; color:#3D1F0A; font-family:Georgia,serif; outline:none; width:100%; transition:border-color .2s; }
  .tc-inp:focus { border-color:#C2651A; }
  .tc-inp.err   { border-color:#C0392B; }
  .tc-inp::placeholder { color:#B08060; font-style:italic; }
  .tc-inp.sel-style { appearance:none; background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 5 5-5' stroke='%235C3A1E' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E"); background-repeat:no-repeat; background-position:right 2px center; padding-right:20px; cursor:pointer; }

  .tc-ta { border:1px solid #D9C9B4; border-radius:8px; padding:10px 12px; font-size:13px; background:#FFFAF5; color:#3D1F0A; font-family:Georgia,serif; outline:none; width:100%; resize:vertical; min-height:80px; transition:border-color .2s,box-shadow .2s; }
  .tc-ta:focus { border-color:#C2651A; box-shadow:0 0 0 3px rgba(194,101,26,.08); }
  .tc-ta::placeholder { color:#B08060; font-style:italic; }

  .tc-pills { display:flex; gap:8px; flex-wrap:wrap; margin-top:6px; }
  .tc-pill { padding:7px 18px; border:1.5px solid #C2651A; border-radius:20px; font-size:13px; cursor:pointer; color:#7A3B10; background:white; font-family:'DM Sans',sans-serif; font-weight:600; transition:border-color .18s,background .18s,color .18s,transform .15s,box-shadow .18s; }
  .tc-pill:hover:not(.sel) { color:#C2651A; transform:translateY(-2px); box-shadow:0 4px 10px rgba(194,101,26,.15); }
  .tc-pill.sel { border-color:#C2651A; background:#C2651A; color:white; box-shadow:0 4px 12px rgba(194,101,26,.25); }
  .tc-pill.sel:hover { background:#A0510E; border-color:#A0510E; }

  .tc-cb-grid { display:grid; grid-template-columns:1fr 1fr; gap:8px; margin-top:8px; }
  .tc-cb-item { display:flex; align-items:center; gap:9px; padding:10px 13px; border:1px solid #D9C9B4; border-radius:8px; cursor:pointer; font-size:13px; color:#3D1F0A; background:#FFFAF5; font-family:'DM Sans',sans-serif; font-weight:500; user-select:none; transition:border-color .18s,background .18s,transform .15s,box-shadow .15s; }
  .tc-cb-item:hover { border-color:#C2651A; transform:translateX(3px); box-shadow:2px 0 10px rgba(194,101,26,.08); }
  .tc-cb-item.chk { border-color:#C2651A; background:#FFF1E6; }
  .tc-cb-box { width:17px; height:17px; border-radius:4px; border:1.5px solid #C2651A; flex-shrink:0; display:flex; align-items:center; justify-content:center; transition:all .18s; }
  .tc-cb-item.chk .tc-cb-box { background:#C2651A; }

  .tc-lifestyle-grid { display:grid; grid-template-columns:1fr 1fr; gap:16px; }
  .tc-lifestyle-card { border:1px solid #D9C9B4; border-radius:10px; padding:16px; background:#FFFAF5; transition:border-color .2s,box-shadow .2s,transform .2s; }
  .tc-lifestyle-card:hover { border-color:#C2651A; box-shadow:0 4px 16px rgba(194,101,26,.08); transform:translateY(-2px); }
  .tc-lifestyle-title { display:flex; align-items:center; gap:8px; font-size:13px; font-weight:600; color:#3D1F0A; font-family:'DM Sans',sans-serif; margin-bottom:12px; }

  .tc-consent { border:1px solid #D9C9B4; border-radius:8px; padding:14px 16px; font-size:12.5px; color:#5C3A1E; line-height:1.8; margin-bottom:18px; font-style:italic; background:#FFFAF5; font-weight:500; transition:border-color .2s; }
  .tc-consent:hover { border-color:#C2651A; }

  .tc-err-banner { background:#FEF2F0; border:1px solid #F5C0B0; border-radius:8px; padding:12px 16px; font-size:13px; color:#9B2D1F; margin-bottom:16px; font-family:'DM Sans',sans-serif; font-weight:500; }

  .tc-submit-row { display:flex; justify-content:space-between; align-items:center; padding-top:24px; border-top:.5px solid #EAE0D4; margin-top:4px; gap:16px; }
  .tc-submit-note { font-size:12px; color:#7A5230; font-family:'DM Sans',sans-serif; font-style:italic; font-weight:500; }

  .tc-submit-btn { background:#C2651A; color:white; border:none; padding:13px 30px; border-radius:10px; font-size:14px; font-family:Georgia,serif; cursor:pointer; letter-spacing:.02em; display:flex; align-items:center; gap:10px; position:relative; overflow:hidden; transition:background .2s,transform .15s,box-shadow .2s; }
  .tc-submit-btn::before { content:''; position:absolute; inset:0; background:linear-gradient(120deg,transparent 0%,rgba(255,255,255,.12) 50%,transparent 100%); transform:translateX(-100%); transition:transform .5s; }
  .tc-submit-btn:hover { background:#A0510E; transform:translateY(-2px); box-shadow:0 8px 20px rgba(194,101,26,.35); }
  .tc-submit-btn:hover::before { transform:translateX(100%); }
  .tc-submit-btn:active { transform:translateY(0); box-shadow:none; }
  .tc-submit-btn:disabled { opacity:.55; cursor:not-allowed; transform:none !important; box-shadow:none !important; }

  .tc-spinner { width:15px; height:15px; border:2px solid rgba(251,245,238,.3); border-top-color:#FBF5EE; border-radius:50%; animation:tc-spin .7s linear infinite; flex-shrink:0; }
  @keyframes tc-spin { to { transform:rotate(360deg); } }

  @media(max-width:768px) {
    .tc-clinic-logo, .tc-clinic-logo-img { height:104px; }
    .tc-clinic-logo { width:104px; }
    .tc-clinic-logo-img { max-width:160px; }
  }

  @media(max-width:580px) {
    .tc-g2,.tc-g3,.tc-lifestyle-grid,.tc-cb-grid { grid-template-columns:1fr; }
    .tc-form-head,.tc-body { padding-left:18px; padding-right:18px; }
    .tc-clinic-bar { flex-direction:column; align-items:flex-start; }
    .tc-clinic-right { align-items:flex-start; }
    .tc-clinic-divider { display:none; }
  }

  @media(max-width:400px) {
    .tc-clinic-logo, .tc-clinic-logo-img { height:80px; }
    .tc-clinic-logo { width:80px; }
    .tc-clinic-logo-img { max-width:130px; }
  }
`;

/* ─── Icons ───────────────────────────────────────────────────────────── */
const IconHeartRate = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="2,12 6,12 8,6 10,18 12,10 14,14 16,12 22,12" />
  </svg>
);
const IconPin = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C2651A" strokeWidth="2" strokeLinecap="round">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
    <circle cx="12" cy="9" r="2.5"/>
  </svg>
);
const IconPhone = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C2651A" strokeWidth="2" strokeLinecap="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
  </svg>
);
const IconClock = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C2651A" strokeWidth="2" strokeLinecap="round">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12,6 12,12 16,14"/>
  </svg>
);
const IconSmoke = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#C2651A" strokeWidth="2" strokeLinecap="round">
    <path d="M18 12H2v4h16v-4z"/><path d="M22 12v4"/><path d="M19 12V6a2 2 0 00-2-2"/><path d="M22 6a2 2 0 00-2-2"/>
  </svg>
);
const IconGlass = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#C2651A" strokeWidth="2" strokeLinecap="round">
    <path d="M8 22h8M12 22v-7M5 2h14l-4 9a5 5 0 01-6 0L5 2z"/>
  </svg>
);

/* ─── Small components ────────────────────────────────────────────────── */
function InjectCSS() {
  return <style dangerouslySetInnerHTML={{ __html: GLOBAL_CSS }} />;
}

function SLabel({ children }) {
  return <div className="tc-slabel">{children}</div>;
}

function Field({ label, error, mb, children }) {
  return (
    <div className="tc-field" style={mb ? { marginBottom: mb } : undefined}>
      <label>{label}</label>
      {children}
      {error && <span className="tc-err-text">{error}</span>}
    </div>
  );
}

function TcInput({ error, ...props }) {
  return <input className={`tc-inp${error ? " err" : ""}`} {...props} />;
}

function TcSelect({ children, ...props }) {
  return (
    <select className="tc-inp sel-style" {...props}>
      {children}
    </select>
  );
}

function TcTextarea({ style, ...props }) {
  return <textarea className="tc-ta" style={style} {...props} />;
}

function PillGroup({ options, value, onChange }) {
  return (
    <div className="tc-pills">
      {options.map(o => (
        <button
          key={o}
          type="button"
          className={`tc-pill${value === o ? " sel" : ""}`}
          onClick={() => onChange(o)}
        >
          {o}
        </button>
      ))}
    </div>
  );
}

function CheckItem({ label, checked, onToggle }) {
  return (
    <label className={`tc-cb-item${checked ? " chk" : ""}`} onClick={onToggle}>
      <div className="tc-cb-box">
        {checked && (
          <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
            <polyline points="1,4 3.5,6.5 9,1" stroke="white" strokeWidth="2" strokeLinecap="round" />
          </svg>
        )}
      </div>
      {label}
    </label>
  );
}

/* ─── Main component ──────────────────────────────────────────────────── */
export default function IntakeFormTerracotta({ token, orgId, hin, dob: prefillDob, logo, orgInfo, onSubmitted }) {
  const [submitting, setSubmitting]   = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [errors, setErrors]           = useState({});

  // personal
  const [firstName, setFirstName]                   = useState("");
  const [lastName, setLastName]                     = useState("");
  const [dateOfBirth, setDateOfBirth]               = useState(prefillDob || "");
  const [healthCard, setHealthCard]                 = useState("");
  const [healthCardProvince, setHealthCardProvince] = useState("");
  const [sex, setSex]                               = useState("");

  // contact
  const [phone, setPhone]           = useState("");
  const [email, setEmail]           = useState("");
  const [address, setAddress]       = useState("");
  const [city, setCity]             = useState("");
  const [province, setProvince]     = useState("BC");
  const [postalCode, setPostalCode] = useState("");

  // emergency
  const [ecName, setEcName]                 = useState("");
  const [ecRelationship, setEcRelationship] = useState("");
  const [ecPhone, setEcPhone]               = useState("");

  // medical
  const [visitReason, setVisitReason] = useState("");
  const [medications, setMedications] = useState("");
  const [allergies, setAllergies]     = useState("");
  const [conditions, setConditions]   = useState({});

  // lifestyle
  const [smoking, setSmoking] = useState("");
  const [alcohol, setAlcohol] = useState("");

  // consent
  const [signature, setSignature]                   = useState("");
  const [signatureDate, setSignatureDate]           = useState(today);
  const [signerRelationship, setSignerRelationship] = useState("");

  const toggleCondition = (label) =>
    setConditions(prev => ({ ...prev, [label]: !prev[label] }));

  /* validate */
  const validate = () => {
    const e = {};
    if (!firstName.trim())   e.firstName    = "Required";
    if (!lastName.trim())    e.lastName     = "Required";
    if (!dateOfBirth)        e.dateOfBirth  = "Required";
    if (!sex)                e.sex          = "Required";
    if (!phone.trim())       e.phone        = "Required";
    if (!address.trim())     e.address      = "Required";
    if (!ecName.trim())      e.ecName       = "Required";
    if (!ecPhone.trim())     e.ecPhone      = "Required";
    if (!visitReason.trim()) e.visitReason  = "Required";
    if (!signature.trim())   e.signature    = "Required";
    if (!signatureDate)      e.signatureDate = "Required";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  /* submit */
  const handleSubmit = async () => {
    if (!validate()) return;
    setSubmitError(null);
    setSubmitting(true);

    const formData = {
      personalInfo:     { firstName, lastName, dateOfBirth, healthCard, healthCardProvince, sex },
      contact:          { phone, email, address, city, province, postalCode },
      emergencyContact: { name: ecName, relationship: ecRelationship, phone: ecPhone },
      medicalHistory:   {
        visitReason, medications, allergies,
        conditions: Object.keys(conditions).filter(k => conditions[k]),
      },
      lifestyle: { smoking, alcohol },
      consent:   { signature, signatureDate, signerRelationship },
    };

    const uploadRes = await uploadPdf(token, orgId, hin, formData);
    if (uploadRes.status !== 200) {
      const msg = uploadRes.data?.message || uploadRes.error?.response?.data?.message
        || "We couldn't submit your form. Please try again.";
      setSubmitError(msg);
      setSubmitting(false);
      return;
    }

    try {
      await setTokenExpired(token, orgId);
    } catch (err) {
      console.error("Failed to mark token expired:", err);
    }

    setSubmitting(false);
    onSubmitted();
  };

  return (
    <>
      <InjectCSS />
      <div className="tc-root">
        <div className="tc-wrap">

          {/* Clinic bar: logo left | address+phone right — all from props */}
          <div className="tc-clinic-bar">
            <div className="tc-clinic-left">
              {logo
                ? <img src={logo} alt="Clinic logo" className="tc-clinic-logo-img" />
                : <div className="tc-clinic-logo"><IconHeartRate /></div>
              }
            </div>
            <div className="tc-clinic-right">
              {orgInfo?.address && (
                <div className="tc-clinic-info"><IconPin /> {orgInfo.address}</div>
              )}
              {orgInfo?.contactNum && (
                <div className="tc-clinic-info"><IconPhone /> {orgInfo.contactNum}</div>
              )}
            </div>
          </div>

          {/* Form card */}
          <div className="tc-card">

            {/* Header */}
            <div className="tc-form-head">
              <div>
                <div className="tc-eyebrow">New patient · Confidential</div>
                <div className="tc-form-title">Patient<br /><span>intake form</span></div>
                <div className="tc-form-sub">
                  Please complete all sections before your appointment.<br />
                  Fields marked * are required.
                </div>
              </div>
              <div className="tc-date-block">
                <div className="tc-date-dow">{DAYS[now.getDay()]}</div>
                <div className="tc-date-day">{String(now.getDate()).padStart(2, "0")}</div>
                <div className="tc-date-mon">{MONTHS[now.getMonth()]}</div>
                <div className="tc-date-yr">{now.getFullYear()}</div>
              </div>
            </div>

            <div className="tc-body">

              {/* Error banner */}
              {(submitError || Object.keys(errors).length > 0) && (
                <div className="tc-err-banner">
                  {submitError || "Please fill in all required fields marked with *."}
                </div>
              )}

              {/* Personal */}
              <div className="tc-section">
                <SLabel>Personal information</SLabel>
                <div className="tc-g3">
                  <Field label="First name *" error={errors.firstName}>
                    <TcInput value={firstName} onChange={e => setFirstName(e.target.value)} placeholder="Jane" error={errors.firstName} />
                  </Field>
                  <Field label="Last name *" error={errors.lastName}>
                    <TcInput value={lastName} onChange={e => setLastName(e.target.value)} placeholder="Smith" error={errors.lastName} />
                  </Field>
                  <Field label="Date of birth *" error={errors.dateOfBirth}>
                    <TcInput type="date" value={dateOfBirth} onChange={e => setDateOfBirth(e.target.value)} error={errors.dateOfBirth} />
                  </Field>
                </div>
                <div className="tc-g2">
                  <Field label="Health card number">
                    <TcInput value={healthCard} onChange={e => setHealthCard(e.target.value)} placeholder="1234-567-890" />
                  </Field>
                  <Field label="Province of issue">
                    <TcSelect value={healthCardProvince} onChange={e => setHealthCardProvince(e.target.value)}>
                      <option value="">Select…</option>
                      {PROVINCES.map(p => <option key={p} value={p}>{p}</option>)}
                    </TcSelect>
                  </Field>
                </div>
                <Field label="Sex assigned at birth *" error={errors.sex}>
                  <PillGroup options={["Male","Female","Intersex","Prefer not to say"]} value={sex} onChange={setSex} />
                </Field>
              </div>

              {/* Contact */}
              <div className="tc-section">
                <SLabel>Contact details</SLabel>
                <div className="tc-g2">
                  <Field label="Phone number *" error={errors.phone}>
                    <TcInput value={phone} onChange={e => setPhone(e.target.value)} placeholder="(604) 555-0100" error={errors.phone} />
                  </Field>
                  <Field label="Email address">
                    <TcInput type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" />
                  </Field>
                </div>
                <Field label="Home address *" error={errors.address} mb={16}>
                  <TcInput value={address} onChange={e => setAddress(e.target.value)} placeholder="Street address" error={errors.address} />
                </Field>
                <div className="tc-g3 no-mb">
                  <Field label="City">
                    <TcInput value={city} onChange={e => setCity(e.target.value)} placeholder="Surrey" />
                  </Field>
                  <Field label="Province">
                    <TcSelect value={province} onChange={e => setProvince(e.target.value)}>
                      {PROVINCES.map(p => <option key={p} value={p}>{p}</option>)}
                    </TcSelect>
                  </Field>
                  <Field label="Postal code">
                    <TcInput value={postalCode} onChange={e => setPostalCode(e.target.value)} placeholder="V3X 0A0" />
                  </Field>
                </div>
              </div>

              {/* Emergency */}
              <div className="tc-section">
                <SLabel>Emergency contact</SLabel>
                <div className="tc-g3 no-mb">
                  <Field label="Full name *" error={errors.ecName}>
                    <TcInput value={ecName} onChange={e => setEcName(e.target.value)} placeholder="John Smith" error={errors.ecName} />
                  </Field>
                  <Field label="Relationship">
                    <TcSelect value={ecRelationship} onChange={e => setEcRelationship(e.target.value)}>
                      <option value="">Select…</option>
                      {RELATIONSHIPS.map(r => <option key={r} value={r}>{r}</option>)}
                    </TcSelect>
                  </Field>
                  <Field label="Phone number *" error={errors.ecPhone}>
                    <TcInput value={ecPhone} onChange={e => setEcPhone(e.target.value)} placeholder="(604) 555-0100" error={errors.ecPhone} />
                  </Field>
                </div>
              </div>

              {/* Medical */}
              <div className="tc-section">
                <SLabel>Medical history</SLabel>
                <Field label="Reason for visit today *" error={errors.visitReason} mb={16}>
                  <TcTextarea value={visitReason} onChange={e => setVisitReason(e.target.value)} placeholder="Briefly describe your symptoms or reason for today's visit…" />
                </Field>
                <Field label="Current medications (include dosage if known)" mb={16}>
                  <TcTextarea value={medications} onChange={e => setMedications(e.target.value)} placeholder="List any prescription or over-the-counter medications, vitamins, or supplements…" />
                </Field>
                <Field label="Allergies (medications, food, environmental)" mb={16}>
                  <TcTextarea value={allergies} onChange={e => setAllergies(e.target.value)} placeholder="List all known allergies and describe your reaction…" style={{ minHeight: 64 }} />
                </Field>
                <Field label="Do you have any of the following? (check all that apply)">
                  <div className="tc-cb-grid">
                    {CONDITIONS.map(c => (
                      <CheckItem key={c} label={c} checked={!!conditions[c]} onToggle={() => toggleCondition(c)} />
                    ))}
                  </div>
                </Field>
              </div>

              {/* Lifestyle */}
              <div className="tc-section">
                <SLabel>Lifestyle</SLabel>
                <div className="tc-lifestyle-grid">
                  <div className="tc-lifestyle-card">
                    <div className="tc-lifestyle-title"><IconSmoke /> Smoking status</div>
                    <PillGroup options={["Never","Former","Current"]} value={smoking} onChange={setSmoking} />
                  </div>
                  <div className="tc-lifestyle-card">
                    <div className="tc-lifestyle-title"><IconGlass /> Alcohol use</div>
                    <PillGroup options={["None","Occasional","Regular"]} value={alcohol} onChange={setAlcohol} />
                  </div>
                </div>
              </div>

              {/* Consent */}
              <div className="tc-section">
                <SLabel>Consent &amp; signature</SLabel>
                <div className="tc-consent">
                  I authorize the clinic to collect, use, and disclose my personal health information
                  for the purpose of providing medical care. I confirm that the information provided
                  is accurate to the best of my knowledge. I consent to examination and treatment as
                  deemed necessary by the attending physician.
                </div>
                <div className="tc-g2">
                  <Field label="Patient signature *" error={errors.signature}>
                    <TcInput value={signature} onChange={e => setSignature(e.target.value)} placeholder="Type full name as signature" error={errors.signature} />
                  </Field>
                  <Field label="Date *" error={errors.signatureDate}>
                    <TcInput type="date" value={signatureDate} onChange={e => setSignatureDate(e.target.value)} error={errors.signatureDate} />
                  </Field>
                </div>
                <Field label="If signing on behalf of patient — relationship to patient">
                  <TcInput value={signerRelationship} onChange={e => setSignerRelationship(e.target.value)} placeholder="e.g. Parent, Legal guardian" />
                </Field>
              </div>

              {/* Submit */}
              <div className="tc-submit-row">
                <div className="tc-submit-note">All information is kept strictly confidential</div>
                <button className="tc-submit-btn" disabled={submitting} onClick={handleSubmit}>
                  {submitting && <div className="tc-spinner" />}
                  {submitting ? "Submitting…" : "Submit form →"}
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}